import arrowUp from '../assets/icons/icon-arrow-up.svg';
import alert from '../assets/icons/icon-alert.svg';
import briefcase from '../assets/icons/icon-briefcase.svg';
import check from '../assets/icons/icon-check.svg';
import checkCircle from '../assets/icons/icon-check-circle.svg';
import checklist from '../assets/icons/icon-checklist.svg';
import chevronDown from '../assets/icons/icon-chevron-down.svg';
import chevronLeft from '../assets/icons/icon-chevron-left.svg';
import chevronRight from '../assets/icons/icon-chevron-right.svg';
import chevronUp from '../assets/icons/icon-chevron-up.svg';
import clock from '../assets/icons/icon-clock.svg';
import copy from '../assets/icons/icon-copy.svg';
import clockLarge from '../assets/icons/icon-clock-large.svg';
import desktop from '../assets/icons/icon-desktop.svg';
import dotDev1 from '../assets/icons/icon-dot-dev1.svg';
import dotDev2 from '../assets/icons/icon-dot-dev2.svg';
import dotProd from '../assets/icons/icon-dot-prod.svg';
import envChevron from '../assets/icons/icon-env-chevron.svg';
import filter from '../assets/icons/icon-filter.svg';
import gear from '../assets/icons/icon-gear.svg';
import home from '../assets/icons/icon-home.svg';
import hubot from '../assets/icons/icon-hubot.svg';
import info from '../assets/icons/icon-info.svg';
import key from '../assets/icons/icon-key.svg';
import menuCheck from '../assets/icons/icon-menu-check.svg';
import moon from '../assets/icons/icon-moon.svg';
import note from '../assets/icons/icon-note.svg';
import pencil from '../assets/icons/icon-pencil.svg';
import people from '../assets/icons/icon-people.svg';
import percent from '../assets/icons/icon-percent.svg';
import person from '../assets/icons/icon-person.svg';
import plus from '../assets/icons/icon-plus.svg';
import redPoints from '../assets/icons/icon-red-points.svg';
import search from '../assets/icons/icon-search.svg';
import send from '../assets/icons/icon-send.svg';
import server from '../assets/icons/icon-server.svg';
import signOut from '../assets/icons/icon-sign-out.svg';
import statusActive from '../assets/icons/icon-status-active.svg';
import sun from '../assets/icons/icon-sun.svg';
import sync from '../assets/icons/icon-sync.svg';
import tag from '../assets/icons/icon-tag.svg';
import trash from '../assets/icons/icon-trash.svg';
import unfold from '../assets/icons/icon-unfold.svg';
import x from '../assets/icons/icon-x.svg';

const icons = {
  'arrow-up': arrowUp,
  alert,
  briefcase,
  check,
  'check-circle': checkCircle,
  checklist,
  'chevron-down': chevronDown,
  'chevron-left': chevronLeft,
  'chevron-right': chevronRight,
  'chevron-up': chevronUp,
  clock,
  copy,
  'clock-large': clockLarge,
  desktop,
  'dot-dev1': dotDev1,
  'dot-dev2': dotDev2,
  'dot-prod': dotProd,
  'env-chevron': envChevron,
  filter,
  gear,
  home,
  hubot,
  info,
  key,
  'menu-check': menuCheck,
  moon,
  note,
  pencil,
  people,
  percent,
  person,
  plus,
  'red-points': redPoints,
  search,
  send,
  server,
  'sign-out': signOut,
  'status-active': statusActive,
  sun,
  sync,
  tag,
  trash,
  unfold,
  x,
};

function Icon({ name, size = 18, tone }) {
  if (tone === 'inherit') {
    return (
      <span
        className="icon icon--mono"
        style={{
          width: size,
          height: size,
          maskImage: `url("${icons[name]}")`,
          WebkitMaskImage: `url("${icons[name]}")`,
        }}
      />
    );
  }

  return (
    <img
      className="icon"
      src={icons[name]}
      width={size}
      height={size}
      alt=""
      draggable="false"
    />
  );
}

export default Icon;
